export const defaultSetting = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
};
